module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user-edit/user-edit.component.scss
// module id = ./src/app/user/user-edit/user-edit.component.scss
// module chunks = main